import {
  Component,
  EventEmitter,
  Input,
  OnInit,
  Output,
  ViewChild
} from "@angular/core";
import { Client } from "src/app/services/API/client";

interface ICountry {
  name: {
    [key: string]: string;
  };
  code: string;
  dial_code: string;
  flag: string;
}

@Component({
  selector: "modal-country-selector",
  templateUrl: "./modal-country-selector.component.html"
  // styleUrls: ["./modal-operator-reconfirm-number.component.css"]
})
export class ModalCountrySelector implements OnInit {
  // @Output() mobileNumberSubmitted: EventEmitter<string> = new EventEmitter<string>();
  // // * One/Albtelecom
  @Input() isOpen: boolean;
  @Input() onClose: () => void;
  @Input() onSelect: (item: ICountry) => void;

  options: ICountry[];
  loading: boolean;
  selected: ICountry;
  searchString: string;

  // @ViewChild("mobileNumber") mobileNumber;

  constructor(private client: Client) {
    this.options = [];
    this.loading = true;
    this.searchString = "";
  }

  ngOnInit() {
    this.fetchCountryOptions();
  }

  readonly modalOnErrorStyleObj = {
    height: "90vh",
    overflow: "auto",
    transform: "translate3d(-50%, -5vh, 0)"
  };

  fetchCountryOptions = async () => {
    this.loading = true;
    console.log("fetch");
    try {
      const res: any = await this.client.get("api/user/countries");
      console.log(res);
      this.options = res;
    } catch (error) {
      console.log(error);
    }
    this.loading = false;
  };

  onSelectItem = (country: ICountry) => {
    this.selected = country;
    this.onSelect(country);
  };

  close() {
    this.onClose();
  }

  isSelected = (country: ICountry) =>
    this.selected.code === country.code &&
    this.selected.dial_code === country.dial_code;

  fileredOptions = () => {
    const searchString = this.searchString.trim().toLowerCase();
    return this.options.filter(
      (op) =>
        op.code.toLowerCase().includes(searchString) ||
        op.dial_code.toLowerCase().includes(searchString) ||
        Object.values(op.name)
          .map((n) => n.toLocaleLowerCase())
          .some((c) => c.includes(searchString))
    );
  };
}
